import React, { useContext, useReducer } from 'react'
import { Classroom as ClassroomConstants } from '@constants'
import { assertContext as assert } from '@helpers'

const initialState = {
  error: null,
  step: ClassroomConstants.STEPS.FETCHING,
  panels: []
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'set_error':
      return { ...state, error: action.payload }
    case 'set_step':
      return { ...state, step: action.payload }
    case 'set_panels':
      return { ...state, panels: action.payload }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

const DispatchContext = React.createContext()
const StateContext = React.createContext()

const SketchpadStateProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  return (
    <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
        {children}
      </DispatchContext.Provider>
    </StateContext.Provider>
  )
}

const useSketchpadState = () => {
  const context = useContext(StateContext)
  assert(context, 'useSketchpadState', 'SketchpadStateProvider')
  return context
}

const useSketchpadStateDispatch = () => {
  const context = useContext(DispatchContext)
  assert(context, 'useSketchpadStateDispatch', 'SketchpadStateProvider')
  return context
}

export { useSketchpadState, SketchpadStateProvider, useSketchpadStateDispatch }
